// eslint-disable-next-line import/prefer-default-export
export const countries = [
  {
    countryId: '769a78d0-4e3c-41f4-a85a-9286d320e0ab',
    name: 'Belgium'
  }
];
